import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=1b7a7e40&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"
import style0 from "./Index.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/landun/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b7a7e40')) {
      api.createRecord('1b7a7e40', component.options)
    } else {
      api.reload('1b7a7e40', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=1b7a7e40&", function () {
      api.rerender('1b7a7e40', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/page/uploader/Index.vue"
export default component.exports